import { ReportsApi } from "@/api/reports";
import { User } from "@/types";
import { QueryKey } from "@/utils";
import { useInfiniteQuery } from "@tanstack/react-query";

export const useGetUserReports = ({
  page,
  userId,
  perPage,
}: {
  page: number;
  perPage: number;
  userId?: User["id"];
}) => {
  const { data, isPending, fetchNextPage } = useInfiniteQuery({
    queryKey: [QueryKey.REPORT, userId],
    queryFn: ({ pageParam }: { pageParam: number }) => {
      return ReportsApi.getReports({
        perPage,
        page: pageParam,
        userId: userId ?? "",
      });
    },
    enabled: !!userId,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage.meta.page + 1;
      return nextPage <= lastPage.meta.totalPages ? nextPage : undefined;
    },
    select: ({ pages }) => {
      return pages.flatMap((data) => data)[page];
    },
  });

  return { reports: data, isPending, fetchNextPage };
};
